import React, { Component } from "react";
import WebFont from "webfontloader";
import IndieFlower from "../assets/font/IndieFlower.ttf";
import { Container, Divider, Header } from "semantic-ui-react";
import Tangible from "./tangible";
import { stageData } from "../data/data";

export class tangibleProject extends Component {
  componentWillUnmount() {
    this.tangible.destroy();
    this.tangible = null;
    delete this.tangible;
  }
  render() {
    WebFont.load({
      custom: {
        families: ["indie-flower"],
        urls: [IndieFlower]
      }
    });
    return (
      <Container>
        <Divider hidden />
        <Header as="h1">
          <Header.Content>Tangible</Header.Content>
          <Header.Subheader>Independent project</Header.Subheader>
        </Header>
        <Divider />
        <div
          className="tangible-playground"
          ref={tangible => {
            if (!tangible) return;
            this.tangible = new Tangible({
              target: tangible,
              data: stageData,
              width: stageData.width,
              height: stageData.height,
              path: {
                img: "",
                audio: ""
              }
            });
          }}
        />
        <div className="iframe-container iframe-container-9by16">
          <iframe
            title="Tangible report"
            src="https://docs.google.com/document/d/e/2PACX-1vSdTK_7NK7bC6zagqfGg6lIEGvoKV5YgVTJS-DVnIf8knVp0m-DUfs-_EO_h-TLfyAotYWzFBEuHgCE/pub?embedded=true"
          />
        </div>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Projects/tangibleProject.js